import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import LoadingScreen from './LoadingScreen';

const AuthGuard: React.FC = () => {
  const { user, loading, initialized } = useAuthStore();

  if (loading && !initialized) {
    return <LoadingScreen />;
  }

  if (!user && initialized) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default AuthGuard;
